import React from 'react';
import { isNil } from 'lodash';
import { Card } from 'antd';
import { useQuery } from 'react-query';

import DataGrid, { formatDate } from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { getScoringFileList, ScoringView } from 'services/scoring';
import ScoringModal from 'pages/Scoring/ScoringDetail/ScoringModal';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';

type AnalysisProps = {
  objectid?: number;
  refetchProp: any;
  isActive?: boolean;
};

const Analysis = ({ objectid, refetchProp,isActive }: AnalysisProps) => {
  
  return (
    <Card
      title={
        <GetLabel
          label="Analysis"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
      className="p-13"
    >
      {isActive &&
      <ScoringTable objectid={objectid} refetchProp={refetchProp} />}
    </Card>
  );
};

export default Analysis;

type ScoringTableProps = {
  objectid?: number;
  refetchProp: any;
};

const ScoringTable = ({ objectid, refetchProp }: ScoringTableProps) => {
  const { data, isFetching } = useGetScoringFileList(objectid, refetchProp);

  const columns: DataGridColDef<ScoringView>[] = [
    {
      comcode: 'scoring.scoreference',
      dataIndex: 'scoreference',
      width: 100,
      render: (scoreference, record) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a onClick={() => setVisible(true)}>{scoreference}</a>
          )}
          modal={({ setVisible, visible }) => (
            <ScoringModal
              scoid={record.scoid}
              visible={visible}
              onCancel={() => setVisible(false)}
              onSuccess={() => setVisible(false)}
            />
          )}
        />
      ),
    },
    {
      comcode: 'scoring.scodate',
      dataIndex: 'scodate',
      width: 100,
      valueFormatter: formatDate,
    },
    {
      comcode: 'scoring.scodecisioncodelabel',
      dataIndex: 'scodecisioncodelabel',
      width: 200,
    },
    {
      comcode: 'scoring.scodecisionlevellabel',
      dataIndex: 'scodecisionlevellabel',
      width: 200,
    },
    {
      comcode: 'scoring.scoscore',
      dataIndex: 'scoscore',
      width: 100,
    },
    {
      comcode: 'scoring.sconote',
      dataIndex: 'sconote',
      width: 100,
    },
    {
      comcode: 'scoring.scoanalystopinion',
      dataIndex: 'scoanalystopinionlabel',
      width: 100,
    },
    {
      comcode: 'scoring.scostatus',
      dataIndex: 'scostatuslabel',
      width: 100,
    },
  ];

  return (
    <DataGrid
      columns={columns}
      titleComcode="AnalysisList"
      dataSource={data}
      isLoading={isFetching}
      rowKey={({ scoid }) => scoid}
    />
  );
};

const useGetScoringFileList = (objectid?: number, refetchProp?: any) => {
  return useQuery(
    ['getScoringFileList', { objectid, refetchProp }],
    () =>
      getScoringFileList({ objectid: objectid!, objecttype: 'PROPOSAL' }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(objectid),
    }
  );
};
